export type IGetPasswordContent = (modal: IjQueryElmOrHtmlElm, button: IjQueryElmOrHtmlElm) => void;

export function _getPasswordContent(modal: IjQueryElmOrHtmlElm, button: IjQueryElmOrHtmlElm): void {
  const $button = $(button);
  const $modal = $(modal) as IjQueryElm;
  const action = $button.data('action'); // change || temp || security-question
  const getUrl = $button.data('href');
  const passedJson = $button.data('json');
  const json =
    typeof passedJson === 'string' ? JSON.parse(decodeURIComponent(passedJson)) : passedJson;
  const { title, successMessage, successTitle, errorMessage, errorTitle } = json;
  // Modal components
  const $modalTitle = $modal.find('.modal-custom-title');
  const $modalBody = $modal.find('.modal-body');
  const $confirmButton = $modal.find('.btn-ok');

  let $form: JQuery<HTMLFormElement>;
  let formAction: string;
  let postUrl: string;

  function processPostResult(obj: IDCA.IPostResponse) {
    if (action === 'change' || action === 'temp' || action === 'security-question') {
      if (obj.success === 'false') {
        window.DexeroCoreApp.userToastMsg('error', errorTitle, errorMessage);
        window.DexeroCoreApp.displayJsonErrors(obj.formError, '');
      } else {
        window.DexeroCoreApp.userToastMsg('success', successTitle, successMessage);
        $modal.modal('hide');
      }
    }
  }

  function clearFormErrors($formToClear: JQuery<HTMLFormElement>) {
    $formToClear.find('.form-group').removeClass('has-error');
    $formToClear.find('.error-block').addClass('hide').attr('aria-hidden', 'true');
  }

  function linkSelectQuestionToResponse(f: JQuery<HTMLFormElement> | HTMLFormElement) {
    const $thisForm = $(f);
    const $selects = $thisForm.find('.sq_selects');

    function updateInputName($select: JQuery<HTMLSelectElement>) {
      const currentValue = $select.find('option:selected').val();
      const $linkedInput = $select.closest('.form-group').find('input');
      const newId = currentValue || getNonTakenId();
      const $otherInputWithSameId = $thisForm.find(`input[name="${newId}"]`);

      function getNonTakenId() {
        let id;
        $select.find('option').each((_, opt) => {
          const optVal = $(opt).val();
          if (optVal !== '') {
            if (!$thisForm.find(`input[name="${optVal}"]`).not($linkedInput).length) {
              id = optVal;
              return false;
            }
          }
          return;
        });
        return id;
      }

      // Remove dulicate input ids
      if (currentValue && $otherInputWithSameId.length) {
        const tempId = getNonTakenId();
        $otherInputWithSameId.attr({
          id: tempId,
          name: tempId,
        });
      }
      $linkedInput.attr({
        id: newId,
        name: newId,
      });
    }
    $selects.each((_, select) => {
      $(select).on('change', (e) =>
        updateInputName($((e as any).currentTarget) as JQuery<HTMLSelectElement>)
      );
    });
  }

  // Get content
  $.get(getUrl).done((data) => {
    $modalTitle.empty().html(title);
    $modalBody.empty().html(data);
    // Get form
    $form = $modalBody.find('form') as any;
    formAction = $form.attr('action') as string;
    postUrl = `${formAction}${window.DexeroCoreApp.getUrlSeperator(formAction)}ajax=true`;
    // Bind confirm button of modal
    $confirmButton.off('click').on('click', () => {
      // Block UI elements
      window.DexeroCoreApp.blockUI(undefined, $form);
      window.DexeroCoreApp.animateButton($confirmButton);
      // Clear form errors
      clearFormErrors($form);
      // Post form
      $.post(postUrl, $form.serialize())
        .done((postResponseData) => {
          processPostResult(postResponseData);
        })
        .always(() => {
          // Unblock UI elements
          window.DexeroCoreApp.blockUI(undefined, $form, true);
          window.DexeroCoreApp.animateButton($confirmButton);
        });
    });
    // Force unique dropdown selections
    if (action === 'security-question') {
      window.DexeroCoreApp.forceUniqueSelectValues($form);
      linkSelectQuestionToResponse($form);
    }
  });
}
